import { gql } from "@apollo/client";

const skillsQuery = gql`
  query skills {
    skills {
      name
      description
    }
  }
`;

export default skillsQuery;
